export default function Hero() {
  return (
    <section className="relative h-[200px] w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20botanical%20nursery%20interior%20with%20rows%20of%20lush%20green%20potted%20foliage%20and%20young%20seedlings%2C%20warm%20golden%20hour%20light%20filtering%20through%20glass%20greenhouse%20panels%2C%20inviting%20garden%20center%20atmosphere%20with%20soft%20natural%20shadows%2C%20professional%20editorial%20photography%20with%20rich%20emerald%20green%20tones%20and%20organic%20harmonious%20composition&width=1920&height=1080&seq=login-hero-bg&orientation=landscape"
          alt="Botanical nursery interior with potted plants"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight">
          Customer Login
        </h1>
      </div>
    </section>
  );
}